<template>
    <CRow style="padding-top: 100px;">
        <CCol col="12">
            <h1>Hello Test --- {{id}}</h1>
        </CCol>
    </CRow>

</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: "CHN",
        props:{
            // used for receive data from Parent
            // Syntax: Name of variable of Parent : Type of variable
            // Example => Courses : Array,
        },
        data(){
            return{
                id: this.$route.params.id
                // used for declare local variable to use in this class
                // Syntax : Name of variable : Default value
                // Example => courses: []
            }
        },
        methods:{
            // used for define functions in each case
            // Syntax : Name of method(){ Actions }
            // Example => onLogin(){ this.$store.dispatch('auth/onLogin') }
        },
        computed:{
            // used for detect data, in this project usually detect the response data from API
            // that collect in the getters of store (vuex)
            // bringing mapGetters to detect in getters of store (vuex)
            // syntax : ...mapGetters({ Name created variable for local data : Name of getters in store })
            // Example => ...mapGetters({ courses : 'courses/allCourses' })
        },
        watch:{
            // used to manage data after detect data
            // Syntax : Existing name of local variable : function(value){ Action }
            // Example => course : function(value){ this.data = value }
            // Value in parameter is the value of detected data changing
        },
        created() {
            // used for manage event when this page open
        },
        mounted() {
            // used for manage event when data has changed
        },
        beforeDestroy() {
            // used for update value before close this page
            // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
        },
    }
</script>

<style scoped>
    .iframe-style{
        width:100vw;
        height:auto;
        min-height: 93vh;
        padding-top: 1px;
    }
</style>